module.exports = __webpack_public_path__ + "static/img/10.8cb0e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/10.png
// module id = zavS
// module chunks = 35